import { useEffect } from "react";

function BoeiWidget() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://app.boei.help/embed/k/e48a559c-c01c-4e27-b743-50a53ac6c4b0";
    script.async = true;
    script.id = "boei-widget-script";
    document.body.appendChild(script);

    return () => {
      let boeiScript = document.getElementById("boei-widget-script");
      if (boeiScript) {
        document.body.removeChild(boeiScript);
      }

      //now we remove other elements Boei created
      let boeiElements = document.querySelectorAll(
        '[id*="boei"],[class*="boei"]'
      );
      boeiElements.forEach((element) => element.remove());
    };
  }, []);
  return null;
}

export default BoeiWidget;
